/**
 * Pick only the top-level field names from a flat (preorder DFS) parquet schema.
 *
 * Group fields — lists, maps, structs — carry `num_children > 0` and their
 * descendants follow them in the array.  Without skipping those subtrees the
 * preview surfaces parquet's intermediate group field names (`list`, `element`
 * for a `list<element: T>` column) as ghost columns alongside the real ones.
 *
 * The row array `parquetRead` returns has one cell per top-level field, so the
 * column-name array has to match that shape too.
 */
export function topLevelColumnNames(schema: { name?: string; num_children?: number }[]): string[] {
    const names: string[] = [];
    const rootChildCount = schema[0]?.num_children ?? schema.length - 1;
    let i = 1; // schema[0] is the root
    let topLevelCount = 0;
    while (i < schema.length && topLevelCount < rootChildCount) {
        names.push(schema[i].name ?? '');
        // Walk this subtree to its end, then continue at the next sibling.
        // `balance` tracks unconsumed children of currently open groups.
        let balance = 1;
        while (balance > 0 && i < schema.length) {
            balance -= 1;
            balance += schema[i].num_children ?? 0;
            i += 1;
        }
        topLevelCount += 1;
    }
    return names;
}
